import React from "react";
import { Link } from "react-router-dom";
function BlogWapper() {
  return (
    <div>
      <div className="bg-dark-secondary">
        <div className="divider"></div>

        <div className="container">
          <div className="row g-5">
            {/* Blog Card */}
            <div className="col-12 col-md-6">
              <div className="blog-card style-five pe-lg-5">
                <img src="assets/img/bg-img/32.jpg" alt="" />
                <div className="blog-meta d-flex align-items-center gap-2">
                  <Link to="#">September 08, 2024</Link>
                  <div className="dot"></div>
                  <Link to="#">Family Law</Link>
                </div>
                <Link className="post-title" to="/blogdetails">
                  A Guide to Practicing Law in Multiple States
                </Link>
              </div>
            </div>

            <div className="col-12 col-md-6">
              <div className="section-heading">
                <div className="sub-title text-white">
                  <img src="assets/img/core-img/hammer.png" alt="" />
                  Our Blog
                </div>
                <h2 className="mb-3 text-white">Latest News & Articles</h2>
                <p className="mb-4 text-white">
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s, when an unknown.
                </p>
                <Link to="/blogone" className="btn btn-primary">
                  <span>
                    View All Blogs <i className="ti ti-arrow-up-right"></i>
                  </span>
                  <span>
                    View All Blogs <i className="ti ti-arrow-up-right"></i>
                  </span>
                </Link>
              </div>

              <div className="d-flex gap-4 mt-5">
                <div className="blog-small-card">
                  <Link to="/blogdetails">
                    <img
                      className="w-100"
                      src="assets/img/bg-img/33.jpg"
                      alt=""
                    />
                  </Link>
                </div>

                <div className="blog-small-card">
                  <Link to="/blogdetails">
                    <img
                      className="w-100"
                      src="assets/img/bg-img/34.jpg"
                      alt=""
                    />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="divider"></div>
      </div>
    </div>
  );
}

export default BlogWapper;
